import { OverlayOption, OverlayOptions } from 'components/OverlayOptions';
import FileType from 'data/FileType';
import { TemplateUI } from 'data/FlyerData';
import * as React from 'react';
import { storeDispatch } from 'state/Store';
import * as Actions from 'state/actions';
import { pause, selectLocalFiles } from 'utils';
import { Overlay } from '../components/Overlay';
import { useMobileLayout } from 'hooks/useMobileLayout';

interface Props {
  property: TemplateUI;
}

export const TemplateImageReplaceModal: React.FunctionComponent<
  Props
> = props => {
  const didChooseOption = async (key: string) => {
    console.log('Option: ' + key);
    switch (key) {
      case 'search':
        storeDispatch(Actions.closeModal(true));
        storeDispatch(Actions.showUnsplashSelector(props.property));
        break;
      case 'computer':
      case 'device':
        const files = await selectLocalFiles(FileType.Image);
        if (files.length) {
          storeDispatch(Actions.closeModal());
          await pause(1);
          storeDispatch(
            Actions.changeTemplateProperty(props.property, files[0])
          );
        }
        break;
      default:
        break;
    }
  };

  const isMobile = useMobileLayout();

  const items: OverlayOption[] = [
    {
      key: 'search',
      title: 'Search professional photo',
      cta: 'Search'
    },
    {
      key: isMobile ? 'device' : 'computer',
      title: `Select from your ${isMobile ? 'device' : 'computer'}`,
      cta: 'Select'
    }
  ];

  return (
    <Overlay title="Replace image">
      <OverlayOptions items={items} onSelect={didChooseOption} />
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/modals/TemplateImageReplaceModal.tsx